import React from 'react';

const Login = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="login_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      // style="enable-background:new 0 0 32 32;"
      space="preserve"
      style={{
        // enableBackground: 'new 0 0 32 32',
        fill: fill || 'currentColor',
        verticalAlign: 'middle',
      }}
    >
      <path d="M20.31,15.56c1.92-1.28,3.19-3.47,3.19-5.95c0-3.95-3.2-7.15-7.15-7.15c-3.95,0-7.15,3.2-7.15,7.15 c0,2.48,1.27,4.67,3.19,5.95c-4.52,1.62-7.75,5.95-7.75,11.03c0,0.81,0.08,1.6,0.24,2.36l1.82-0.37v0c-0.13-0.64-0.2-1.31-0.2-1.99	c0-2.72,1.1-5.18,2.89-6.97c1.71-1.71,4.03-2.79,6.61-2.88c0.12,0.01,0.23,0.02,0.35,0.02c0.12,0,0.23-0.01,0.35-0.02	c2.58,0.09,4.91,1.17,6.61,2.88c1.78,1.79,2.89,4.24,2.89,6.97c0,0.68-0.07,1.35-0.2,1.99l1.82,0.37c0.16-0.76,0.24-1.55,0.24-2.36	C28.06,21.51,24.83,17.19,20.31,15.56z M12.61,13.35c-0.96-0.96-1.55-2.28-1.55-3.74c0-1.46,0.59-2.78,1.55-3.74	c0.96-0.96,2.28-1.55,3.74-1.55c1.46,0,2.78,0.59,3.74,1.55c0.96,0.96,1.55,2.28,1.55,3.74c0,1.46-0.59,2.78-1.55,3.74 c-0.88,0.88-2.06,1.44-3.39,1.53c-0.12,0-0.23-0.01-0.35-0.01s-0.24,0.01-0.35,0.01C14.68,14.8,13.49,14.23,12.61,13.35z" />
    </svg>
  );
};

export default Login;
